<section ng-if="!tooManyRecipients && ready" class="concerned-groups">
    <div ng-if="concernedGroups.length === 0 && recipients.length < 1">{{'setCurrentStage.noneWillBeNotified'|translate}}</div>
    <div ng-if="concernedGroups.length > 0">{{'setCurrentStage.whoIsNotified' | translate}}</div>
    <p>
        <ul>
            <li ng-repeat="group in concernedGroups">
                {{group.Name | localize}}
            </li>
        </ul>
    </p>
</section>

<section ng-if="!tooManyRecipients && ready" class="concerned-groups">
    {{"notify.extra.recipients"|translate}}
    <c-multi-item-picker config="pickerConfig" selected-item-ids="notificationRecipientIds" items="notificationRecipients"></c-multi-item-picker>
</section>

<section ng-if="!tooManyRecipients && ready && !workflowIsRestricted()" class="concerned-groups">
    {{"notify.extra.grouprecipients"|translate}}
    <c-multi-item-picker config="groupPickerConfig" selected-item-ids="notificationGroupRecipientIds" items="notificationGroupRecipients"></c-multi-item-picker>
</section>

<section ng-if="tooManyRecipients && ready && !workflowIsRestricted()" class="concerned-groups">
    <div class="multiline-text">{{'setCurrentStage.tooManyRecipients' | translate}}</div>

    {{"notify.emailGroupRecipients"|translate}}
    <c-multi-item-picker config="pickerEmailGroupsConfig" selected-item-ids="emailGroupIds" items="emailGroups"></c-multi-item-picker>

    {{"notify.extra.recipients2"|translate}}
    <c-multi-item-picker config="pickerConfig" selected-item-ids="notificationRecipientIds" items="notificationRecipients"></c-multi-item-picker>
</section>

<section ng-if="tooManyRecipients && workflowIsRestricted()" class="concerned-groups">
    <div class="multiline-text">{{'setCurrentStage.tooManyRecipients.restricted' | translate}}</div>
</section>
